import { createFileRoute } from '@tanstack/react-router'
import { ShieldOff } from 'lucide-react'
import { EmptyState } from '@/components/data/EmptyState'
import { SybilClusterDetailView } from '@/components/mlro/SybilClusterDetailView'
import { useRoles } from '@/hooks/useRoles'

export const Route = createFileRoute('/mlro/sybil/$id')({
    component: MlroSybilDetailPage,
})

function MlroSybilDetailPage() {
    const { id } = Route.useParams()
    const { hasAnyRole } = useRoles()

    if (!hasAnyRole('mlro')) {
        return (
            <EmptyState
                icon={ShieldOff}
                title="No access"
                description="The MLRO surfaces are restricted to operators with the MLRO role."
            />
        )
    }

    return <SybilClusterDetailView clusterId={id} />
}
